import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';
import { FilterOperationType, type IFilter, type ISingleFilter } from '@chax-at/prisma-filter-common';
import type { IUserFeedbackFilter } from 'common/interface/filter.interface';
import { EUserFeedbackStatusFilter } from 'common/enum/misc.enum';

export const buildUserFeedbackStatusFilter = (
  status: EUserFeedbackStatusFilter,
): ISingleFilter<IUserFeedbackFilter>[] => {
  switch (status) {
    case EUserFeedbackStatusFilter.ALL:
      return [];
    case EUserFeedbackStatusFilter.OPEN:
      return [{ field: 'handledAt', type: FilterOperationType.EqNull, value: null }];
    case EUserFeedbackStatusFilter.HANDLED:
      return [{ field: 'handledAt', type: FilterOperationType.NeNull, value: null }];
  }
};

export async function fetchUserFeedback(params?: {
  filter?: IFilter<IUserFeedbackFilter>;
  search?: string;
}): Promise<{ count: number; rows: Components.Schemas.UserFeedbackDto[] }> {
  const res = await Api.Routes.UserFeedbackProvider.retrieve({ $filter: params?.filter, search: params?.search });
  return res;
}

export async function deleteUserFeedback(params: { id: number }): Promise<void> {
  await Api.Routes.UserFeedbackProvider.delete({ id: params.id });
}

export async function setUserFeedbackHandled(params: { id: number; handled: boolean }): Promise<void> {
  await Api.Routes.UserFeedbackProvider.setHandled({ id: params.id }, { handled: params.handled });
}
